import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AppInsightsService } from '../app-insights.service';
import { IDocumentMergeModel, IMergerInputModel } from 'src/app/Shared/models/DocumentMerge';
import { IEmailBodyInput, ISendEmailOutputModel } from 'src/app/Shared/interface2';
import {AppService} from '../app.service';

@Injectable({
    providedIn: 'root',
})

export class DocumentGenService {

    private baseURL = this.appService.config.apiBaseUrl;

    constructor(private http: HttpClient,
                private appinsights: AppInsightsService,
                private appService: AppService) { }


    MergeTenantInfoSheet(documentModel: IDocumentMergeModel): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), };
        let url = `${this.baseURL}/DocumentMerger/MergeTenantInfoSheet`;
        return this.http.post<any>(url, documentModel, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    MergeMilitaryAddendum(documentModel: IDocumentMergeModel): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), };
        let url = `${this.baseURL}/DocumentMerger/MergeMilitaryAddendum`;
        return this.http.post<any>(url, documentModel, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    MergeVehicleAddendum(documentModel: IDocumentMergeModel): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), };
        let url = `${this.baseURL}/DocumentMerger/MergeVehicleAddendum`;
        return this.http.post<any>(url, documentModel, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    GenerateTenantDocument(documentModel: IMergerInputModel): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), };
        let url = `${this.baseURL}/DocumentMerger/GenerateTenantDocument`;
        return this.http.post<any>(url, documentModel, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getEmailBody(emailbodyinput: IEmailBodyInput): Observable<ISendEmailOutputModel> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/EmailAndSMS/GetBatchFollowUpEmail`;
        return this.http.post<ISendEmailOutputModel>(url, emailbodyinput, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

      GetTemplatesforEmailandSMSByTransactionType(facId, transTypeId):Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/DocumentMerger/GetTemplatesforEmailandSMSByTransactionType?facilityId=${facId}&transactionTypeId=${transTypeId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    return res.body;
                }),
                catchError(this.handleError)
            );
      }  

      
    getEmailAndSMSSetting():Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/EmailAndSMS/GetEmailAndSMSSetting`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    return res.body;
                }),
                catchError(this.handleError)
            );
      }


    private handleError(error: HttpErrorResponse) {
        console.log('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            this.appinsights.logEvent(errMessage);
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }
}

